module.exports = __webpack_public_path__ + "static/media/CrashBandicoot.a92c1d33.jpg";